import { MultiLangModel } from './Language.model';

export class DepartmentModel {
  constructor(data = {}) {
    Object.assign(this, data);
  }

  id: string = '';
  name: MultiLangModel = new MultiLangModel();
}
